import { useState } from "react";
import { http } from "@/lib/api";

const Option = ({ name, value, label, hint, checked, onChange, testid }) => (
  <label data-testid={testid}
    className={`flex cursor-pointer items-start gap-3 border px-3 py-2.5 transition-colors ${checked ? "border-hv-navy bg-hv-section" : "border-hv-rule bg-white hover:border-hv-navy"}`}>
    <input type="radio" name={name} value={value} checked={checked} onChange={onChange} className="mt-1 accent-[#183457]" />
    <span>
      <span className="block font-heading text-[13px] font-semibold text-hv-navy">{label}</span>
      {hint && <span className="block text-[12px] text-hv-muted">{hint}</span>}
    </span>
  </label>
);

export const FundFinder = ({ s, onResult, onClose }) => {
  const steps = s.finderSteps;
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState(["any", "any", "any"]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [title, options] = steps[step];
  const last = step === steps.length - 1;

  const pick = (v) => setAnswers((a) => a.map((x, i) => (i === step ? v : x)));

  const submit = async () => {
    setLoading(true);
    setError("");
    try {
      const { data } = await http.post("/fund-finder", { goal: answers[0], exposure: answers[1], risk: answers[2] });
      const labels = answers.map((v, i) => steps[i][1].find((o) => o[0] === v)[1]);
      onResult(data, labels);
    } catch {
      setError("Sorry, Fund Finder is unavailable right now. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="hv-rise border border-hv-rule bg-white" aria-labelledby="finder-title" data-testid="fund-finder">
      <header className="flex items-center justify-between border-b border-hv-rule px-4 py-2.5">
        <h3 id="finder-title" className="font-heading text-[13px] font-bold text-hv-navy">{s.finder}</h3>
        <span className="font-heading text-[11px] font-semibold text-hv-muted" data-testid="fund-finder-step">{s.finderStep(step + 1, steps.length)}</span>
      </header>
      <div className="h-1 bg-hv-section" aria-hidden="true"><div className="h-1 hv-accent-bg transition-[width] duration-300" style={{ width: `${((step + 1) / steps.length) * 100}%` }} /></div>
      <fieldset className="space-y-2 p-4">
        {step === 0 && <p className="mb-2 text-[12px] text-hv-muted">{s.finderIntro}</p>}
        <legend className="sr-only">{title}</legend>
        <p className="mb-2 font-heading text-[14px] font-bold text-hv-text" aria-hidden="true">{title}</p>
        {options.map(([v, label, hint]) => (
          <Option key={v} name={`finder-${step}`} value={v} label={label} hint={hint} checked={answers[step] === v}
            onChange={() => pick(v)} testid={`fund-finder-option-${step}-${v}`} />
        ))}
      </fieldset>
      {error && <p className="px-4 pb-2 text-[12px] text-hv-navy" role="alert" data-testid="fund-finder-error">{error}</p>}
      <footer className="flex items-center justify-between gap-2 border-t border-hv-rule px-4 py-3">
        <button type="button" onClick={step ? () => setStep(step - 1) : onClose} className="font-heading text-[12px] font-semibold text-hv-muted hover:text-hv-navy" data-testid="fund-finder-back-button">
          {step ? s.finderBack : s.finderCancel}
        </button>
        <button type="button" disabled={loading} onClick={last ? submit : () => setStep(step + 1)} className="hv-btn-light hv-btn-sm" data-testid={last ? "fund-finder-submit-button" : "fund-finder-next-button"}>
          {last ? s.finderShow : s.finderNext}
        </button>
      </footer>
    </section>
  );
};
